import "@story/story_assets/dom_extend";
import { parseLocalizedInt } from "../utils/numbers";

document.addEventSelectorListener("click", "[data-increment]", function(event, target) {
	event.preventDefault();
	let increment = parseLocalizedInt(target.getAttribute("data-increment"));
	let input = target.closest(".input-group").querySelector("input");
	let oldValue = parseLocalizedInt(input.value);
	let newValue = oldValue + increment;

	let minValue = parseLocalizedInt(input.getAttribute("min") || input.getAttribute("data-min"));
	let maxValue = parseLocalizedInt(input.getAttribute("max") || input.getAttribute("data-max"));

	if (Number.isInteger(minValue) && newValue < minValue) {
		newValue = minValue;
	}
	if (Number.isInteger(maxValue) && maxValue < newValue) {
		newValue = maxValue;
	}

	if (oldValue != newValue) {
		input.value = newValue;
		input.trigger("change");
	}
});